import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Invoice } from '@models';
import { BreakpointService } from '@services';
import { formatCost } from '@shared';

@Component({
  selector: 'app-invoice-detailed-info',
  templateUrl: './invoice-detailed-info.component.html',
  styleUrls: ['./invoice-detailed-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoiceDetailedInfoComponent {
  @Input() invoice: Invoice;

  public payerNameTransations = {
    Sender: 'Відправник',
    Recipient: 'Отримувач',
    ThirdPerson: 'Третя особа',
  };

  isDesktop$ = this.breakpointService.isDesktop$;

  constructor(private breakpointService: BreakpointService) {}

  getAnnouncedPrice(invoice: Invoice): string {
    return formatCost(invoice.Cost, invoice.InvoiceCurrencyCode, invoice.isInternational);
  }
}
